import { apiGet, apiPost, apiPut, apiDelete } from '@/utils/api';

const get = async <T>(endpoint: string): Promise<T> => {
  console.log('🔍 API GET Request:', {
    endpoint,
    timestamp: new Date().toISOString()
  });
  
  try {
    const response = await apiGet<T>(endpoint);
    console.log('✅ API GET Success:', {
      endpoint,
      responseType: typeof response,
      timestamp: new Date().toISOString()
    });
    return response;
  } catch (error) {
    console.error('❌ API GET Error:', {
      endpoint,
      error: error instanceof Error ? error.message : error,
      timestamp: new Date().toISOString()
    });
    
    if (!navigator.onLine) {
      throw new Error('You are currently offline. Please check your internet connection and try again.');
    }
    throw error;
  }
};

const post = async <T, U>(endpoint: string, data: T): Promise<U> => {
  console.log('🔍 API POST Request:', {
    endpoint,
    data: data,
    timestamp: new Date().toISOString()
  });
  
  try {
    const response = await apiPost<U>(endpoint, data);
    console.log('✅ API POST Success:', {
      endpoint,
      responseType: typeof response,
      timestamp: new Date().toISOString()
    });
    return response;
  } catch (error) {
    console.error('❌ API POST Error:', {
      endpoint,
      error: error instanceof Error ? error.message : error,
      timestamp: new Date().toISOString()
    });
    
    if (!navigator.onLine) {
      throw new Error('You are currently offline. Please check your internet connection and try again.');
    }
    throw error;
  }
};

const put = async <T, U>(endpoint: string, data: T): Promise<U> => {
  console.log('🔍 API PUT Request:', {
    endpoint,
    data: data,
    timestamp: new Date().toISOString()
  });
  
  try {
    const response = await apiPut<U>(endpoint, data);
    console.log('✅ API PUT Success:', {
      endpoint,
      responseType: typeof response,
      timestamp: new Date().toISOString()
    });
    return response;
  } catch (error) {
    console.error('❌ API PUT Error:', {
      endpoint,
      error: error instanceof Error ? error.message : error,
      timestamp: new Date().toISOString()
    });
    
    if (!navigator.onLine) {
      throw new Error('You are currently offline. Please check your internet connection and try again.');
    }
    throw error;
  }
};

const del = async (endpoint: string): Promise<void> => {
  console.log('🔍 API DELETE Request:', {
    endpoint,
    timestamp: new Date().toISOString()
  });
  
  try {
    await apiDelete(endpoint);
    console.log('✅ API DELETE Success:', {
      endpoint,
      timestamp: new Date().toISOString()
    });
  } catch (error) {
    console.error('❌ API DELETE Error:', {
      endpoint,
      error: error instanceof Error ? error.message : error,
      timestamp: new Date().toISOString()
    });
    
    if (!navigator.onLine) {
      throw new Error('You are currently offline. Please check your internet connection and try again.');
    }
    throw error;
  }
};

export default {
  get,
  post,
  put,
  delete: del,
};
